import { useState, useRef, useEffect, useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import { useNavigate, Link } from "react-router-dom";
import LoginForm from "../../user/components/Auth/LoginForm";
import RegisterForm from "../../user/components/Auth/RegisterForm";

export default function UserNavbar() {
    const [openMain, setOpenMain] = useState(false);
    const [open, setOpen] = useState(false);
    const [openLogin, setOpenLogin] = useState(false);
    const [mode, setMode] = useState("login");
    const ref = useRef();

    const { logout, user } = useContext(AuthContext);
    const navigate = useNavigate();


    // Tutup dropdown jika klik di luar
    useEffect(() => {
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                setOpen(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const handleLogout = () => {
        logout();           // hapus token & reset user
        navigate("/login"); // redirect ke login
        setOpen(false);     // tutup dropdown
        setMode("login")
    };

    return (
    
        <>
            <nav className="navbar d-flex align-items-center justify-content-between px-4 py-2 bg-white border-bottom sticky-top" style={{minHeight: 64}}>
                {/* Kiri: Logo/nama web */}
                <div className="d-none d-md-flex align-items-center gap-3">
                    {/* Menu navigasi */}
                    <Link to="/" className="nav-link px-3 text-gray-700">Home</Link>
                    <Link to="/about" className="nav-link px-3 text-gray-700">About Us</Link>
                </div>

                {/* Mobile Menu */}
                <div className="d-md-none nav-link px-3">
                    <button className="rounded-pill p-4 d-inline-block pe-40 position-relative" type="button" onClick={() => setOpenMain((v) => !v)}>
                        <i className="ph ph-list"></i>
                    </button>
                </div>

                {/* Tambahkan menu lain jika perlu */}
                <Link to="/" className="navbar-brand d-flex align-items-center gap-2 text-decoration-none">
                    {/* <img src="/assets/images/logo/logo.png" alt="Logo" style={{height: 36}} /> */}
                    <span className="fw-bold text-main-600 fs-5">memoliworks</span>
                </Link>
                
                {user && user?.role === "user" && (
                    <>
                        <button
                            className="users arrow-down-icon border border-gray-200 rounded-pill p-4 d-inline-block pe-40 position-relative"
                            type="button"
                            onClick={() => setOpen((v) => !v)}
                        >
                            <span className="position-relative">
                                <img alt="" src="admin-template/images/thumbs/user-img.png" className="h-32 w-32 rounded-circle" />
                                <span className="activation-badge w-8 h-8 position-absolute inset-block-end-0 inset-inline-end-0"></span>
                            </span>
                        </button>
                    </>
                )}

                {!user && (
                    <button
                        className="rounded-pill p-4 d-inline-block pe-40 position-relative"
                        type="button"
                        onClick={() => setOpenLogin((v) => !v)}
                    >
                        <span className="text-gray-500">Login</span>
                    </button>
                )}
            </nav>
                
            {openMain && (
                <div className="position-relative">
                    <div className="dropdown-menu dropdown-menu--lg border-0 bg-transparent p-0 show" style={{ display: "block", left: 0, }}>
                        <div className="card border border-gray-100 rounded-12 box-shadow-custom">
                            <div className="card-body">
                                <ul className="max-h-270 overflow-y-auto scroll-sm pe-4">
                                    <li className="mb-4">
                                        <Link to="/" className="py-12 text-15 px-20 hover-bg-gray-50 text-gray-300 rounded-8 flex-align gap-8 fw-medium text-15">
                                            <span className="text-2xl text-primary-600 d-flex"><i className="ph ph-house"></i></span>
                                            <span className="text">Home</span>
                                        </Link>
                                    </li>
                                    <li className="mb-4">
                                        <Link to="/about" className="py-12 text-15 px-20 hover-bg-gray-50 text-gray-300 rounded-8 flex-align gap-8 fw-medium text-15">
                                            <span className="text-2xl text-primary-600 d-flex"><i className="ph ph-info"></i></span>
                                            <span className="text">About Us</span>
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Kanan: User/Login */}

            {open && (
                <div ref={ref} className="position-relative">
                    <div className="dropdown-menu dropdown-menu--lg border-0 bg-transparent p-0 show" style={{ display: "block", right: 0, }}>
                        <div className="card border border-gray-100 rounded-12 box-shadow-custom">
                            <div className="card-body">
                                <div className="flex-align gap-8 mb-20 pb-20 border-bottom border-gray-100">
                                    <img src="admin-template/images/thumbs/user-img.png" alt="" className="w-54 h-54 rounded-circle" />
                                    <div>
                                        <h4 className="mb-0">{user?.name}</h4>
                                        <p className="fw-medium text-13 text-gray-200">{user?.email}</p>
                                    </div>
                                </div>
                                <ul className="max-h-270 overflow-y-auto scroll-sm pe-4">
                                    <li className="mb-4">
                                        <Link to="/" className="py-12 text-15 px-20 hover-bg-gray-50 text-gray-300 rounded-8 flex-align gap-8 fw-medium text-15">
                                            <span className="text-2xl text-primary-600 d-flex"><i className="ph ph-house"></i></span>
                                            <span className="text">Home</span>
                                        </Link>
                                    </li>
                                    <li className="mb-4">
                                        <Link to="/orders" className="py-12 text-15 px-20 hover-bg-gray-50 text-gray-300 rounded-8 flex-align gap-8 fw-medium text-15">
                                            <span className="text-2xl text-primary-600 d-flex"><i className="ph ph-receipt"></i></span>
                                            <span className="text">Pesanan</span>
                                        </Link>
                                    </li>
                                    <li className="pt-8 border-top border-gray-100">
                                        <a href="#" onClick={handleLogout} className="py-12 text-15 px-20 hover-bg-danger-50 text-gray-300 hover-text-danger-600 rounded-8 flex-align gap-8 fw-medium text-15">
                                            <span className="text-2xl text-danger-600 d-flex"><i className="ph ph-sign-out"></i></span>
                                            <span className="text">Log Out</span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {openLogin && (
                <div ref={ref} className="position-relative">
                    <div className="dropdown-menu dropdown-menu--lg border-0 bg-transparent p-0 show" style={{ display: "block", right: 0, }}>
                        <div className="card border border-gray-100 rounded-12 box-shadow-custom">
                            <div className="card-body">
                                {mode === "login" ? (
                                    <LoginForm onSwitchToRegister={() => setMode("register")} onSuccess={() => {setMode(null); setOpenLogin(false)}} />
                                ) : mode === "register" ? (
                                    <RegisterForm onSwitchToLogin={() => setMode("login")} onSuccess={() => {setMode(null); setOpenLogin(false)}} />
                                ) : (<></>)
                            }
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}